module.exports = __webpack_public_path__ + "img/search.da46dc9a.png";